const byName = (a, b) => {
  let aName = a.name.toLowerCase()
  let bName = b.name.toLowerCase()

  if (a.reading && b.reading) {
    aName = a.reading
    bName = b.reading
  }

  if (aName < bName) {
    return -1
  }

  if (aName > bName) {
    return 1
  }

  return 0
}

export const convertDataToIngredients = data => data.sort(byName)
